<template>
  <div id="addCustomer">
    <a-form-model :model="saveForm" ref="ruleForm" >
      <div class="customerFormDiv">
        <a-row :gutter="20">
          <a-col :span="12">
            <a-form-model-item prop="area"  :label="$t('customer.customAttributeDetail.area')">
              <a-input-number style='width: 100%' v-model="saveForm.attributeArea" :placeholder="$t('customer.customAttributeDetail.inputTip')"></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="startPrice"  :label="$t('customer.customAttributeDetail.price')">
              <div class="ptSlider">
                <a-rate v-model:value="saveForm.attributeStart" />
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="trackPersonDOS"  :label="$t('customer.customAttributeDetail.agent')">
            <ptSelect mode='multiple' v-model='saveForm.attributeTracks' :placeholder="$t('track.trackModal.opponentTip')"
                      :maxTagCount=1 :maxTagTextLength='6'>
              <a-select-option v-for='c in competitors' :key='c.id' :value='c.id' :disabled='!c.selectable'>
                <div style='display:flex;'>
                  <div style='flex:1;' class='invisible-item'>
                    {{ c.companyName }}
                  </div>
                  <div>
                    {{ c.companySortNameCn }}
                  </div>
                </div>
              </a-select-option>
            </ptSelect>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </div>
</template>
<script>


import colleagueApi from '@/api/database/colleague'
import Api from '@/api/mine/customerAttributes'

export default {
  name: 'customerAttribute',

  props: {
    customerId: null,
  },

  data(){
    return {
      currStep: 0,
      competitors:[],
      saveForm: {
        attributeArea:undefined,
        attributeStart:undefined,
        attributeTracks:[],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods:{

    init(){
      this.initCompetitors()
      this.initCustomerAttribute()
    },

    initCustomerAttribute(){
      Api.selectOne(this.customerId).then(res=>{
        if(res.code == 1){
          if(res.data){
            Object.assign(this.saveForm,res.data)
          }
        }
      })
    },

    initCompetitors(){
      colleagueApi.selectAll().then(res=>{
        if(res.code == 1){
          this.competitors = res.data.records
        }
      })
    },
    getData(){
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(err=> {
          if (err) {
            console.log(this.saveForm)
            resolve(this.saveForm)
          }else{
            this.$message.warning("请正确输入表单")
            reject()
          }
        })
      })
    }
  }
}

</script>
<style scoped lang="less">
#addCustomer{
  .customerFormDiv{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 20px;
  }

  .ptSlider {
    display: flex;
    flex-direction: row;
    align-items: center;


  }




}

</style>